import { render, staticRenderFns } from "./DictionaryValueTableRoot.vue?vue&type=template&id=46c28810&scoped=true"
import script from "./DictionaryValueTableRoot.vue?vue&type=script&lang=js"
export * from "./DictionaryValueTableRoot.vue?vue&type=script&lang=js"
import style0 from "./DictionaryValueTableRoot.vue?vue&type=style&index=0&id=46c28810&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c28810",
  null
  
)

export default component.exports